import { render, staticRenderFns } from "./AnswerWithButton.vue?vue&type=template&id=abd9a36e&scoped=true&"
import script from "./AnswerWithButton.vue?vue&type=script&lang=js&"
export * from "./AnswerWithButton.vue?vue&type=script&lang=js&"
import style0 from "./AnswerWithButton.vue?vue&type=style&index=0&id=abd9a36e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd9a36e",
  null
  
)

export default component.exports